module.exports = __webpack_public_path__ + "static/media/2 japanese oriental dragon fullsleeve tattoo black and grey.1280x1707.e6e58008.webp";